<template>
  <page>
    <div class="home">
      <app-header>
        Memento Mori {{ !isMobile ? 'Calendar' : null }}
      </app-header>

      <div class="inputs">
        <label>
          <div class="date-picker-label">Enter your date of birth</div>
          <date-picker v-model="birthDay" />
        </label>

        <button
          class="generate-button"
          @click="handleGenerateClicked"
        >
          Generate
        </button>
      </div>
    </div>
  </page>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Page from '@/components/Page.vue'
import DatePicker from '@/components/DatePicker.vue'
import AppHeader from '@/components/AppHeader.vue'
import router from '@/router'
import { useMediaQuery } from '@/composables/useMediaQuery'

export default defineComponent({
  name: 'Home',

  components: {
    DatePicker,
    Page,
    AppHeader
  },

  setup () {
    return {
      ...useMediaQuery()
    }
  },

  data () {
    return {
      birthDay: ''
    }
  },

  methods: {
    handleGenerateClicked () {
      router.push({ path: 'calendar', query: { birthDay: this.birthDay } })
    }
  }
})
</script>

<style scoped>
  .inputs {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
  }

  .date-picker-label {
    display: flex;
    justify-content: center;
    margin: 15px 0;
    font-size: 1.2rem;
  }

  .generate-button {
    margin-top: 25px;
    width: 150px;
    height: 40px;
    font-size: 1.2rem;
    border-radius: 4px;
    cursor: pointer;
    border: 1px black solid;
    background-color: rgb(250, 250, 250);
  }

</style>
